import { cn } from '@heidi/utils';

import type { SkeletonProps } from './skeleton.types';

function Skeleton({ className, ...props }: SkeletonProps) {
  return (
    <div
      className={cn('animate-pulse rounded-md bg-background-secondary', className)}
      {...props}
    />
  );
}

export { Skeleton };
